import React from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { PlayerHub } from '../organisms/PlayerHub';
import { Settings } from '../../interfaces';
import { TicketData } from '../organisms/TicketView';
import { BannerWithSearchBar } from '../organisms/BannerWithSearchBar';
import { useSettings } from '../../stateManagement/SettingsContext';
import { Layout } from '../templates';

interface PlayerHubPagePreviewProps {
  settings: Settings;
  onTicketClick: () => void;
  onClickMyTickets: () => void;
  onClickLandingPageButton: () => void;
  onContactUsClick: () => void;
}
export const PlayerHubPagePreview: React.FC<PlayerHubPagePreviewProps> = ({
  settings,
  onTicketClick,
  onClickMyTickets,
  onClickLandingPageButton,
  onContactUsClick,
}) => {
  const { dummyMyTicketsData } = useSettings(); // now from context
  const { t }: { t: (key: string, options?: { returnObjects: boolean }) => any } = useTranslation();
  const helperTexts = t('data.helperTexts', { returnObjects: true });
  // Extract ticket data and full ticket object from context
  const ticketList = dummyMyTicketsData?.dummyTicketData || [];
  const fullTicket = dummyMyTicketsData?.dataInTicket;

  const transformTicketData = (item: any, issueId: number): TicketData | null => {
    if (!item || item.id !== issueId) return null;

    return {
      ticketId: String(item.id),
      status: item.state_data?.state || 'Unknown',
      messages: item.messages
        ? item.messages.map((msg: any) => ({
            sender: msg.origin === 'end-user' ? msg.author?.emails?.[0] || 'Unknown' : msg.origin,
            timestamp: msg.created_at ? new Date(msg.created_at).toISOString() : 'Unknown Time',
            message: msg.body || 'No Message',
          }))
        : [],
    };
  };

  const handleTicketClick = (issueId: number) => {
    onTicketClick();
    const ticketData = transformTicketData(fullTicket, issueId);

    if (!ticketData) {
      // eslint-disable-next-line no-console
      console.warn(`Ticket data not found for issue ID: ${issueId}`);
    }
  };

  return (
    <Layout
      onClickLandingPageButton={onClickLandingPageButton}
      onClickMyTickets={onClickMyTickets}
      onContactUsClick={onContactUsClick}
      pageBgColor={settings?.configs.secondaryBgColor}
      settings={settings}
      isPreviewMode
    >
      <Box>
        <Box
          display="flex"
          flexDirection="column"
          minHeight="76vh"
          backgroundColor={settings?.configs.secondaryBgColor}
        >
          <BannerWithSearchBar
            isFullScreen={settings?.configs.isBannerFullScreen}
            px={{
              base: '0vw',
              md: '0vw',
              lg: settings?.configs.isBannerFullScreen ? '0vw' : '7vw',
            }}
            imageSrc={settings?.configs.ticketViewPageLogoUrl}
            altText="Contact Us Banner"
            showSearchBar={false}
            bannerTextColor="white"
            placeholderText=""
            showOverlay={undefined}
            bgColor={settings?.configs.secondaryBgColor}
            showJaggedBorder={settings?.configs.showJaggedBorder}
            secondaryAccentColor={settings?.configs.secondaryAccentColor}
            placeholderFontSize={{ base: '20px', md: '22px', lg: '24px' }} // Responsive font size
            placeholderFontWeight="bold"
            isPreview
          />

          <Box flex={1}>
            <PlayerHub
              // ticketData={dataForticket}
              PlayerHubTableFields={ticketList}
              settings={settings ?? undefined}
              onTicketClick={handleTicketClick}
              emptyDataHelperText={
                helperTexts.find((item: Record<string, string>) => 'emptyDataHelperText' in item)
                  ?.emptyDataHelperText ?? ''
              }
              isPreview
              // inputValue=""
            />
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};
